import { render } from "./PER_Employees.vue?vue&type=template&id=8ed248fe&scoped=true&ts=true"
import script from "./PER_Employees.vue?vue&type=script&lang=ts"
export * from "./PER_Employees.vue?vue&type=script&lang=ts"

import "./PER_Employees.vue?vue&type=style&index=0&id=8ed248fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed248fe"]])

export default __exports__